{
  "jsm-cbp-grace-period-notification.message.link.extra.objects": [
    {
      "type": 0,
      "value": "Get extra objects"
    }
  ],
  "jsm-cbp-grace-period-notification.message.link.learn.more": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "jsm-cbp-grace-period-notification.message.link.manage.usage": [
    {
      "type": 0,
      "value": "Manage usage"
    }
  ],
  "jsm-cbp-grace-period-notification.message.text.ninety.days": [
    {
      "type": 0,
      "value": "Consumption-based pricing will come into effect after "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "daysRemaining"
    }
  ],
  "jsm-cbp-grace-period-notification.message.text.thirty.days": [
    {
      "type": 0,
      "value": "Extra usage of Assets and the virtual service agent in Jira Service Management will be billed."
    }
  ],
  "jsm-cbp-grace-period-notification.message.title.ninety.days": [
    {
      "type": 0,
      "value": "You are nearing the end of your Grace period"
    }
  ],
  "jsm-cbp-grace-period-notification.message.title.thirty.days": [
    {
      "type": 0,
      "value": "Consumption-based pricing starts in "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "daysRemaining"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.heading": [
    {
      "type": 0,
      "value": "Consumption-based pricing starts with your next renewal"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.hello": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.intro": [
    {
      "type": 0,
      "value": "We’re letting you know that Assets and Virtual service agent will move to consumption-based pricing at your next renewal on "
    },
    {
      "type": 1,
      "value": "cbpEffectiveDate"
    },
    {
      "type": 0,
      "value": ". Additional charges will only apply if your usage exceeds the included limit. Check your current usage and learn more below."
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.need-to-know": [
    {
      "type": 0,
      "value": "Helpful things to know:"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.comment.alt-text": [
    {
      "type": 0,
      "value": "comment"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.lightbulb.alt-text": [
    {
      "type": 0,
      "value": "lightbulb"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.optimize-schema": [
    {
      "children": [
        {
          "type": 0,
          "value": "Contact support"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " if you have any questions"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.usage-limit": [
    {
      "type": 0,
      "value": "Consider "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "optimizing the structure of your schemas"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.more-details-button": [
    {
      "type": 0,
      "value": "More details"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.subject": [
    {
      "type": 0,
      "value": "[Reminder] Upcoming pricing changes to Assets and Virtual Service Agent"
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.support.annual.feature-usage-limits-guide": [
    {
      "type": 0,
      "value": "For more information, read more about "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "how feature usage limits work"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.view-and-manage-usage-button": [
    {
      "type": 0,
      "value": "View and manage usage"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.body.agent-limit": [
    {
      "type": 0,
      "value": "Get "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "unlimited agents"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "250 GB file storage"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.body.ai-written-support": [
    {
      "type": 0,
      "value": "Power your Rovo agent with "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "AI written support articles"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.body.assets": [
    {
      "type": 0,
      "value": "Track business "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "assets"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " and link them to work items"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.body.disclaimer": [
    {
      "type": 0,
      "value": "We will automatically upgrade you to a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "14-day free trial"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " of our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Standard plan"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ". You can "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "switch back to the Free plan"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " anytime by reducing your limits."
    }
  ],
  "jsm-sequoia.nearing-storage-limit.body.rovo-ai-agents": [
    {
      "type": 0,
      "value": "Resolve requests and incidents faster with "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Rovo AI agents"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.button.try-standard": [
    {
      "type": 0,
      "value": "Try Standard for free"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.caption.body": [
    {
      "type": 0,
      "value": "You've used at least 1.8 GB of the 2 GB storage available on the Free plan. Once you reach 2 GB, you'll be upgraded to the 14-day free trial of our Standard plan."
    }
  ],
  "jsm-sequoia.nearing-storage-limit.caption.disclaimer": [
    {
      "type": 0,
      "value": "What happens once storage is full?"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.caption.heading": [
    {
      "type": 0,
      "value": "You're almost out of storage"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.email-header-alt": [
    {
      "type": 0,
      "value": "Service Collection"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.email-header-customer-service-management": [
    {
      "type": 0,
      "value": "Customer Service Management"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.email-header-jira-service-management": [
    {
      "type": 0,
      "value": "Jira Service Management"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.email-header-rovo": [
    {
      "type": 0,
      "value": "Rovo"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.email-header-subtitle": [
    {
      "type": 0,
      "value": "Includes:"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.footer.atlassian-logo-alt": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. "
    }
  ],
  "jsm-sequoia.nearing-storage-limit.footer.dot-separator": [
    {
      "type": 0,
      "value": "•"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.footer.facebook-alt-text": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.footer.facebook-title": [
    {
      "type": 0,
      "value": "Facebook"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.footer.linkedin-alt-text": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.footer.linkedin-title": [
    {
      "type": 0,
      "value": "LinkedIn"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.footer.office-address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.footer.partner-portal": [
    {
      "type": 0,
      "value": "Partner Portal"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.footer.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.footer.read-our-blog": [
    {
      "type": 0,
      "value": "Read our blog"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.footer.unsubscribe": [
    {
      "children": [
        {
          "type": 0,
          "value": "Unsubscribe"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " to opt out of future emails like this"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.footer.x-alt-text": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.footer.x-title": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.footer.youtube-alt-text": [
    {
      "type": 0,
      "value": "Youtube"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.footer.youtube-title": [
    {
      "type": 0,
      "value": "Youtube"
    }
  ],
  "jsm-sequoia.nearing-storage-limit.link.explore-plans": [
    {
      "type": 0,
      "value": "Explore all plans"
    }
  ],
  "jsm-sequoia.service-collection-nearing-storage-limit-awareness.email.subject": [
    {
      "type": 0,
      "value": "You are about to reach your limit"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.avatar.alt_text.user_avatar": [
    {
      "type": 0,
      "value": "User Avatar"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.connection": [
    {
      "type": 0,
      "value": "Connection"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.csm": [
    {
      "type": 0,
      "value": "Customer Service Management"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.id-badge": [
    {
      "type": 0,
      "value": "ID Badge"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.jsm": [
    {
      "type": 0,
      "value": "Jira Service Management"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.service-collection": [
    {
      "type": 0,
      "value": "Service Collection"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.csm.description": [
    {
      "type": 0,
      "value": "Deliver better customer support and quickly turn feedback into product improvements."
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.csm.title": [
    {
      "type": 0,
      "value": "Delight external customers with purpose-built features"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.jsm.description": [
    {
      "type": 0,
      "value": "Make internal support easier by enabling HR, IT, and other teams to resolve employee requests quickly."
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.jsm.title": [
    {
      "type": 0,
      "value": "Unite teams to deliver exceptional service experiences"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.alt_text.atlassian": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.contact_us": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. "
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.location": [
    {
      "type": 0,
      "value": "We are located at 341 George Street, Sydney, NSW, 2000, Australia."
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.privacy_policy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.read_our_blog": [
    {
      "type": 0,
      "value": "Blog"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.twitter.no-translate": [
    {
      "type": 0,
      "value": "Twitter"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.header.greeting": [
    {
      "type": 0,
      "value": "Hey "
    },
    {
      "type": 1,
      "value": "adminName"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.header.message": [
    {
      "type": 1,
      "value": "requestingUserName"
    },
    {
      "type": 0,
      "value": " has requested a trial of Service Collection."
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card": [
    {
      "type": 1,
      "value": "requestingUserName"
    },
    {
      "type": 0,
      "value": " requested your organization try Service Collection, Atlassian’s solution for AI service management at high velocity."
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card.cta": [
    {
      "type": 0,
      "value": "Try Service Collection for free"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card.review-request-cta": [
    {
      "type": 0,
      "value": "Review request"
    }
  ],
  "jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.subject": [
    {
      "type": 0,
      "value": "Hey "
    },
    {
      "type": 1,
      "value": "adminName"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "type": 1,
      "value": "requestingUserName"
    },
    {
      "type": 0,
      "value": " wants you to start a Service Collection trial"
    }
  ],
  "jsm-servco-uplift-notification.message.button.servco.uplift": [
    {
      "type": 0,
      "value": "Try it now"
    }
  ],
  "jsm-servco-uplift-notification.message.link.learn.more.servco.uplift": [
    {
      "type": 0,
      "value": "What's Service Collection"
    }
  ],
  "jsm-servco-uplift-notification.message.text.servco.uplift": [
    {
      "type": 0,
      "value": "Deliver great service experiences fast with a template designed to help your external customers."
    }
  ],
  "jsm-servco-uplift-notification.message.title.servco.uplift": [
    {
      "type": 0,
      "value": "Try Customer Service Management today with Service Collection"
    }
  ],
  "post-office.ad-controls-sequoia.custom-dropdown-item.1.no-translate": [
    {
      "type": 0,
      "value": "the first custom dropdown item"
    }
  ],
  "post-office.ad-controls-sequoia.custom-dropdown-item.2.no-translate": [
    {
      "type": 0,
      "value": "the second custom dropdown item"
    }
  ],
  "post-office.ad-controls-sequoia.custom-reason.existing-products.no-translate": [
    {
      "type": 0,
      "value": "the second reason for displaying the message to the customer"
    }
  ],
  "post-office.ad-controls-sequoia.custom-reason.team-size.no-translate": [
    {
      "type": 0,
      "value": "the first reason for displaying the message to the customer"
    }
  ],
  "post-office.ad-controls-sequoia.default-reason.existing-products": [
    {
      "type": 0,
      "value": "your existing Atlassian products"
    }
  ],
  "post-office.ad-controls-sequoia.default-reason.team-size": [
    {
      "type": 0,
      "value": "the size of your team"
    }
  ],
  "post-office.ad-controls-sequoia.dismiss-flag.not-interested.subtitle": [
    {
      "type": 0,
      "value": "You won’t see this here as often."
    }
  ],
  "post-office.ad-controls-sequoia.dismiss-flag.not-interested.title": [
    {
      "type": 0,
      "value": "Got it, thanks for letting us know"
    }
  ],
  "post-office.ad-controls-sequoia.dropdown-item.not-interested.label": [
    {
      "type": 0,
      "value": "Not interested"
    }
  ],
  "post-office.ad-controls-sequoia.dropdown-item.remind-me-later.label": [
    {
      "type": 0,
      "value": "Remind me later"
    }
  ],
  "post-office.ad-controls-sequoia.dropdown-item.why-am-i-seeing-this.label": [
    {
      "type": 0,
      "value": "Why am I seeing this?"
    }
  ],
  "post-office.ad-controls-sequoia.dropdown-menu-trigger.aria-label": [
    {
      "type": 1,
      "value": "messageInstanceId"
    },
    {
      "type": 0,
      "value": " options menu"
    }
  ],
  "post-office.ad-controls-sequoia.dropdown-menu-trigger.tooltip": [
    {
      "type": 0,
      "value": "More actions"
    }
  ],
  "post-office.ad-controls-sequoia.reasons-modal.accept-button.label-ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "post-office.ad-controls-sequoia.reasons-modal.body": [
    {
      "type": 0,
      "value": "We think you'd find this relevant. This is based on:"
    }
  ],
  "post-office.ad-controls-sequoia.reasons-modal.privacy-policy-link.text": [
    {
      "type": 0,
      "value": "Learn more about your data privacy with Atlassian"
    }
  ],
  "post-office.ad-controls-sequoia.reasons-modal.title": [
    {
      "type": 0,
      "value": "Why am I seeing this?"
    }
  ],
  "post-office.jsm-assets-premium-trial-dashboard-item.lozenge-try": [
    {
      "type": 0,
      "value": "Try"
    }
  ],
  "post-office.jsm-assets-premium-trial-dashboard-item.menu-item-label": [
    {
      "type": 0,
      "value": "Dashboards"
    }
  ],
  "post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-bullet-one": [
    {
      "type": 0,
      "value": "your current product usage"
    }
  ],
  "post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-bullet-two": [
    {
      "type": 0,
      "value": "features available in premium"
    }
  ],
  "post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-explanation": [
    {
      "type": 0,
      "value": "We think this premium feature will help you get more out of Assets. The recommendation is based on:"
    }
  ],
  "post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-title": [
    {
      "type": 0,
      "value": "Why am I seeing this?"
    }
  ],
  "post-office.jsm-assets-premium-trial-data-manager-item.lozenge-try": [
    {
      "type": 0,
      "value": "Try"
    }
  ],
  "post-office.jsm-assets-premium-trial-data-manager-item.menu-item-label": [
    {
      "type": 0,
      "value": "Data Manager"
    }
  ],
  "post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-bullet-one": [
    {
      "type": 0,
      "value": "your current product usage"
    }
  ],
  "post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-bullet-two": [
    {
      "type": 0,
      "value": "features available in premium"
    }
  ],
  "post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-explanation": [
    {
      "type": 0,
      "value": "We think this premium feature will help you get more out of Assets. The recommendation is based on:"
    }
  ],
  "post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-title": [
    {
      "type": 0,
      "value": "Why am I seeing this?"
    }
  ],
  "post-office.jsm-assets-premium-trial-item.lozenge-try": [
    {
      "type": 0,
      "value": "Try"
    }
  ],
  "post-office.jsm-assets-premium-trial-item.menu-item-label": [
    {
      "type": 0,
      "value": "Assets"
    }
  ],
  "post-office.jsm-assets-premium-trial-item.reasons-modal-bullet-one": [
    {
      "type": 0,
      "value": "your current product usage"
    }
  ],
  "post-office.jsm-assets-premium-trial-item.reasons-modal-bullet-two": [
    {
      "type": 0,
      "value": "features available in premium"
    }
  ],
  "post-office.jsm-assets-premium-trial-item.reasons-modal-explanation": [
    {
      "type": 0,
      "value": "We think this premium feature will help you get more out of Assets. The recommendation is based on:"
    }
  ],
  "post-office.jsm-assets-premium-trial-item.reasons-modal-title": [
    {
      "type": 0,
      "value": "Why am I seeing this?"
    }
  ],
  "post-office.jsm-issue-view-details-section.description": [
    {
      "type": 0,
      "value": "Update incidents from within Slack and summarize key events with AI."
    }
  ],
  "post-office.jsm-issue-view-details-section.dismiss-button-one": [
    {
      "type": 0,
      "value": "I don't use Slack"
    }
  ],
  "post-office.jsm-issue-view-details-section.reasons-modal-bullet-one": [
    {
      "type": 0,
      "value": "your usage of Jira Service Management's Alerts and Incidents features"
    }
  ],
  "post-office.jsm-issue-view-details-section.reasons-modal-explanation": [
    {
      "type": 0,
      "value": "We think Service Collection Premium will improve your team's workflow. The recommendation is based on:"
    }
  ],
  "post-office.jsm-issue-view-details-section.title": [
    {
      "type": 0,
      "value": "Resolve incidents on Slack with AI"
    }
  ]
}